// extracted by mini-css-extract-plugin
module.exports = {"form":"MealForm_form__3rfvD"};